import { c as _c } from "react/compiler-runtime";
import { type FC, useEffect } from 'react';
import { ModalContent } from '@components/modal/ModalContent';
import { ModalHeader } from '@components/modal/ModalHeader';
import { Button, Flex, Text } from '@endurancewarranty/ui';
import { ParameterTypeEnum } from '@lib/enums/ParameterTypeEnum';
import { sidebarDialogAtom } from '@states/dialogs/sidebarDialogAtom';
import { useJotaiAtom } from '@states/jotai/hooks';
export type Props = {
  onClose: () => void;
  params: Record<number, string>;
};
export const ContractModificationDisabledModal: FC<Props> = t0 => {
  const $ = _c(11);
  const {
    params,
    onClose
  } = t0;
  const [, setSidebarDialogState] = useJotaiAtom(sidebarDialogAtom);
  let t1;
  let t2;
  if ($[0] !== setSidebarDialogState) {
    t1 = () => {
      setSidebarDialogState({
        isOpen: false,
        children: null
      });
    };
    t2 = [setSidebarDialogState];
    $[0] = setSidebarDialogState;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ModalHeader title="Cannot adjust contract" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onClose) {
    t4 = <Flex className="w-full justify-end"><Button name="confirm-modification-disabled" onClick={onClose} variant="primary">OK</Button></Flex>;
    $[4] = onClose;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `Cannot rewrite ${params[ParameterTypeEnum.PlanName]} plans within ${params[ParameterTypeEnum.RewriteDisabledDays]} from sold date. Cancel flat, then start a new policy.`;
  let t6;
  if ($[6] !== t5) {
    t6 = <Flex className="mt-4 mb-8"><Text.Body>{t5}</Text.Body>{" "}</Flex>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <ModalContent header={t3} footer={t4}>{t6}</ModalContent>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};